import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
} from '@angular/core';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { InputsModule } from '../../inputs.module';
import { IRadioFancyInput } from '../../interface';
import { BaseInputComponent } from '../base-input/base-input.component';

@Component({
    selector: 'input-radio-fancy',
    templateUrl: './radio-fancy.component.html',
    styleUrl: './radio-fancy.component.scss',
    imports: [InputsModule, InlineSVGModule],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Default
})
export class InputRadioFancyComponent extends BaseInputComponent<IRadioFancyInput> {
  constructor() {
    super();
  }
  override ngOnChanges(): void {
    super.ngOnChanges();
    this.options.control?.disable();
  }

  updateValue() {
    if (!this.options.control) return;
    if (this.options.control?.value === this.options.value) {
      this.options.control.reset();
    } else {
      this.options.control.setValue(this.options.value);
    }
  }
}
